import { Pipe, PipeTransform, Injectable } from "@angular/core";

@Pipe({
  name: "filter",
  pure: false,
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: Array<any>, filter: { [key: string]: any }): Array<any> {
    const filtered = (items || []).filter((item) => {
      return Object.keys(filter).every((key) => {
        if (filter[key]) {
          return item[key].toLowerCase().includes(filter[key].toLowerCase());
        }
        return true;
      });
    });
    return filtered;
  }
}
